export const ASSIGNEE = "Assignee";
export const DELEGATE_1 = "Delegate 1";
export const DELEGATE_2 = "Delegate 2";
export const REMOVE_TEXT = "Remove";
export const EDIT_TEXT = "Edit";